/* eslint-disable @typescript-eslint/no-explicit-any */
// useCreateMedia.ts

import { getAccessToken } from "@/helpers/auth-helpers";
import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import messageService from "@/services/message.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateMediaProps = {
  formData: FormData;
} & RequestsProps;

export type UseCreateMediaReturn = {
  createMedia: (props: CreateMediaProps) => Promise<any | void>;
} & UseLoadingReturn;

const useCreateMedia = (): UseCreateMediaReturn => {
  const accessToken = getAccessToken();
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<FormData>({
    operation: (formData) => messageService.createMedia(formData, accessToken),
  });
  const createMediaWithResult = async (props: CreateMediaProps): Promise<any> => {
    const mediaResult = await create(props);
    return mediaResult;
  };
  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    createMedia: createMediaWithResult,
  };
};

export default useCreateMedia;
